import Loading from '@/common/components/Loading';
import Table from '@/common/components/Table';
import { Wrapper } from '../callingSearch/CallingSearch.styled';
import SearchBox from './components/SearchBox';
import { TABLE_HEADERS } from './constants/table';
import { getTableRows } from './helpers/getTableRows';
import useFollowUpPayments from './hooks/useFollowUpPayments';

const FollowUpPayments = () => {
	const hook = useFollowUpPayments();

	return (
		<>
			{hook.isLoading && <Loading />}
			<Wrapper>
				<SearchBox handleSearchCallback={hook.fetchStalePayments}></SearchBox>
				{hook.displayedRows && (
					<Table
						className='styled-table'
						raws={getTableRows(hook.displayedRows)}
						headers={TABLE_HEADERS}
					/>
				)}
			</Wrapper>
		</>
	);
};

export default FollowUpPayments;
